'use strict';

{
	//JavaScript有効判定
	const htmlElement = document.querySelector('html');
	htmlElement.classList.add('js');

	//告知バー表示判定
	if (document.querySelector('.shopify-section--announcement-bar') !== null) {
		document.body.classList.add('announcement-bar-true');
	}

	//メインビジュアルの高さ設定
	const header = document.querySelector('.header');
	const boxMain = document.querySelector('.box_main');
	let announcementBarHeight;
	function boxMainHeight() {
		if (document.querySelector('.shopify-section--announcement-bar') !== null) {
			announcementBarHeight = document.querySelector('.shopify-section--announcement-bar').offsetHeight;
			console.log(announcementBarHeight);
			boxMain.style.height = 'calc(100vh - ' + announcementBarHeight + 'px)';
		}
		boxMain.style.marginTop = '-' + header.offsetHeight + 'px';
	}
	boxMainHeight();

	//アコーディオンボタン設定
	let thisElement;
	let thisButtonElement;
	let nextElement;
	function accordionEvent() {
		let parentElement = thisElement.closest('.decoration_bg-color-01');
		if (thisElement.getAttribute('aria-expanded') === 'false') {
			thisElement.setAttribute('aria-expanded', 'true');
			nextElement.setAttribute('aria-hidden', 'false');
			nextElement.style.height = nextElement.scrollHeight + 'px';
			if (parentElement != null) {
				parentElement.classList.add('open');
			}
		} else if (thisElement.getAttribute('aria-expanded') === 'true') {
			thisElement.setAttribute('aria-expanded', 'false');
			thisElement.blur();
			nextElement.setAttribute('aria-hidden', 'true');
			nextElement.style.height = null;
			if (parentElement != null) {
				parentElement.classList.remove('open');
			}
		}
	}

	//アコーディオン開閉
	if (document.documentElement.classList.contains('js') == true) {
		const accordionButton = Array.from(document.getElementsByClassName('accordion-button'));
		for (let i = 0; i < accordionButton.length; i++) {
			let button = accordionButton[i];
			let content = button.nextElementSibling;
			button.setAttribute('role', 'button');
			button.setAttribute('aria-expanded', 'false');
			button.setAttribute('aria-controls', 'accordionContent' + [i + 1]);
			button.setAttribute('tabindex', '0');
			content.setAttribute('id', 'accordionContent' + [i + 1]);
			content.setAttribute('aria-hidden', 'true');
			button.addEventListener('click', function () {
				thisElement = this;
				nextElement = this.nextElementSibling;
				accordionEvent();
			});
			button.addEventListener('keydown', function (event) {
				thisElement = this;
				nextElement = this.nextElementSibling;
				if (event.code === 'Enter' || event.code === 'Space') {
					accordionEvent();
					event.preventDefault();
				}
			});
		}
	}

	//リサイズ処理（アコーディオン+告知バーとヘッダーの高さを取得）
	let lastWindowWidth = window.innerWidth;
	let resizeTimer;
	window.addEventListener('resize', function () {
		if (lastWindowWidth != window.innerWidth) {
			lastWindowWidth = window.innerWidth;
			if (resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(function () {
				let accordionActive = document.querySelectorAll('[aria-expanded="true"]');
				for (let i = 0; i < accordionActive.length; i++) {
					thisElement = accordionActive[i];
					nextElement = accordionActive[i].nextElementSibling;
					accordionEvent();
				}
				boxMainHeight();
			}, 200);
		}
	});

	//ページ先頭に戻るボタン
	const pageTopButton = document.querySelector('.page-top');
	window.addEventListener('scroll', function() {
		if (window.scrollY >= 144) {
			pageTopButton.classList.add('active');
		} else {
			pageTopButton.classList.remove('active');
		}
	});
	const pageTopButtonAnchor = document.querySelector('.page-top a');
	pageTopButtonAnchor.addEventListener('focus', function(event) {
		pageTopButton.classList.add('active');
	});
	pageTopButtonAnchor.addEventListener('blur', function(event) {
		pageTopButton.classList.remove('active');
	});
}